// Access control exports
export { checkAccess, RequireAccess, useAccess } from './access'
export type { AccessState } from './access'
// Client-side exports
export { AuthProvider, useAuth, useSession } from './context'
// Cookie exports
export { AUTH_COOKIE_NAME, clearTokenCookie, getTokenFromCookie, setTokenCookie } from './cookies'
export { createAuthFetch } from './fetch'
// Impersonation recovery helpers
export {
  clearImpersonationRecovery,
  getImpersonationRecovery,
  getImpersonationRecoveryRemainingSeconds,
  getImpersonationRecoveryTargetLabel,
  isImpersonationRecoveryExpired,
  saveImpersonationRecovery,
} from './impersonation-recovery'
export { getSafeRedirectPath } from './redirect'
// Token/impersonation helpers
export { getImpersonatorId, getTokenPayload, isImpersonationToken } from './token'
// Type exports
export type {
  AuthState,
  Role,
  Session,
  SessionCompany,
  User,
  UserContact,
  UserContactsData,
} from './types'
export { useUserContacts } from './user-contacts'

export type { AccessRequirements } from '@repo/permissions/access'

export { normalizeName } from '@repo/permissions/access'

// Legacy re-exports for backwards compatibility
// signIn and signOut are no longer needed - use useAuth().login() and useAuth().logout()
// handlers are no longer needed - NextAuth route handlers removed

/**
 * @deprecated Use useAuth().login() instead. This is a no-op stub.
 */
export async function signIn(_provider: string, _options?: Record<string, unknown>) {
  console.warn('signIn() is deprecated. Use useAuth().login() with your token instead.')
}

/**
 * @deprecated Use useAuth().logout() instead
 */
export async function signOut() {
  if (typeof window !== 'undefined') {
    const [{ clearImpersonationRecovery }, { clearTokenCookie }] = await Promise.all([
      import('./impersonation-recovery'),
      import('./cookies'),
    ])
    clearTokenCookie()
    clearImpersonationRecovery()
    window.location.href = '/'
  }
}
